import React from "react";

const ProjectDetails = ({ pfrFormData, setPfrFormData }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPfrFormData("projectDetails", {
      [name]: value,
    });
  };

  return (
    <>
      <div className="form-section">
        <h3>Project Details</h3>
        <div className="form-group">
          <label className="required">Name of the Project</label>
          <input
            type="text"
            name="projectName"
            value={pfrFormData.projectDetails.projectName}
            onChange={handleInputChange}
            placeholder="Enter Project Name"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Project Sector</label>
          <select
            name="projectSector"
            value={pfrFormData.projectDetails.projectSector}
            onChange={handleInputChange}
            required
          >
            <option value="">Select</option>
            <option value="Agriculture">Agriculture</option>
            <option value="Industry">Industry</option>
            <option value="Services">Services</option>
            <option value="Others">Others</option>
          </select>
        </div>
        <div className="form-group">
          <label className="required">Project Category</label>
          <select
            name="projectCategory"
            value={pfrFormData.projectDetails.projectCategory}
            onChange={handleInputChange}
            required
          >
            <option value="">Select</option>
            <option value="A">A</option>
            <option value="B-1">B-1</option>
            <option value="B-2">B-2</option>
          </select>
        </div>
        <div className="form-group">
          <label className="required">City</label>
          <input
            type="text"
            name="projectCity"
            value={pfrFormData.projectDetails.projectCity}
            onChange={handleInputChange}
            placeholder="Enter City"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Tehsil</label>
          <input
            type="text"
            name="projectTehsil"
            value={pfrFormData.projectDetails.projectTehsil}
            onChange={handleInputChange}
            placeholder="Enter Tehsil"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">District</label>
          <input
            type="text"
            name="projectDistrict"
            value={pfrFormData.projectDetails.projectDistrict}
            onChange={handleInputChange}
            placeholder="Enter District"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Project Area (in hectares)</label>
          <input
            type="number"
            name="projectArea"
            value={pfrFormData.projectDetails.projectArea}
            onChange={handleInputChange}
            placeholder="Enter Project Area"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Khasra No.</label>
          <input
            type="text"
            name="projectKhasraNo"
            value={pfrFormData.projectDetails.projectKhasraNo}
            onChange={handleInputChange}
            placeholder="Enter Khasra Number"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Production Capacity</label>
          <input
            type="text"
            name="projectProductionCapacity"
            value={pfrFormData.projectDetails.projectProductionCapacity}
            onChange={handleInputChange}
            placeholder="Enter Production Capacity"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Lease Period (in years)</label>
          <input
            type="number"
            name="projectLeasePeriod"
            value={pfrFormData.projectDetails.projectLeasePeriod}
            onChange={handleInputChange}
            placeholder="Enter Lease Period"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Project Location</label>
          <textarea
            name="projectLocation"
            value={pfrFormData.projectDetails.projectLocation}
            onChange={handleInputChange}
            placeholder="Enter Detailed Project Location"
            required
          />
        </div>
      </div>
      <div className="form-section">
        <h3>Applicant Details</h3>
        <div className="form-group">
          <label className="required">Name of Applicant</label>
          <input
            type="text"
            name="applicantName"
            value={pfrFormData.projectDetails.applicantName}
            onChange={handleInputChange}
            placeholder="Enter Applicant Name"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Address of Applicant</label>
          <textarea
            name="applicantAddress"
            value={pfrFormData.projectDetails.applicantAddress}
            onChange={handleInputChange}
            placeholder="Enter Applicant Address"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Email of Applicant</label>
          <input
            type="email"
            name="applicantEmail"
            value={pfrFormData.projectDetails.applicantEmail}
            onChange={handleInputChange}
            placeholder="Enter Applicant Email"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Mobile of Applicant</label>
          <input
            type="text"
            name="applicantMobile"
            value={pfrFormData.projectDetails.applicantMobile}
            onChange={handleInputChange}
            placeholder="Enter Applicant Mobile"
            required
          />
        </div>
      </div>
    </>
  );
};

export default ProjectDetails;
